import React, {useState} from 'react';
import './onboard-tabs-inner-style.scss';

const OnboardTabsInner = (props) => {

    const {defaultActiveTab, onChange, tabs} = props;
    const [selectTab, setSelectTab] = useState(defaultActiveTab);

    const handleChangeTab = (value) => {
        if (value !== selectTab) {
            setSelectTab(value);
            if (onChange !== undefined)
                onChange(value);
        }
    }

    const getTabs = () => {
        return tabs?.map((tab, index) => {
            return (
                <div key={index} className="onboard-tabs-inner-block-root" onClick={() => handleChangeTab(tab.value)}>
                    <div className={"onboard-tabs-inner-block-text "
                        + (selectTab === tab.value ? 'onboard-tabs-inner-block-active' : '')}>
                        <div className={"onboard-tabs-inner-block-line "
                            + (selectTab === tab.value ? 'onboard-tabs-inner-block-line-active' : '')}/>
                        <p>{tab.label}</p>
                    </div>
                </div>
            )
        })
    }

    return (
        <div className="onboard-tabs-inner-root">
            {getTabs()}
        </div>
    )
};

export default OnboardTabsInner;
